/**
 * MovieOfTheNight entity class
 */

/**
 * MovieOfTheNightFactory
 * returns MovieOfTheNight entity class
 *
 * @class MovieOfTheNightFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.MovieOfTheNight} class
 *
 * @ngdoc factory
 * @name mwApp.factory:MovieOfTheNightFactory
 */
/* @ngInject */
export default function MovieOfTheNightFactory ($injector, $sce, $http, Type, Entity, alertLiteSvc, onOffMixin) {
  /* === MovieOfTheNight class === */

  /**
   * MovieOfTheNight model
   *
   * @class MovieOfTheNight
   * @classdesc MovieOfTheNight model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.MovieOfTheNight} MovieOfTheNight entity
   */
  function MovieOfTheNight () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  MovieOfTheNight.prototype = Object.create(Entity.prototype)
  MovieOfTheNight.prototype.constructor = MovieOfTheNight

  /* === MovieOfTheNight instance methods & fields === */

  Object.assign(MovieOfTheNight.prototype, {

    /**
     * instance fields
     *
     * @memberof models.MovieOfTheNight#
     * @type {Object}
     */
    _fields: {
      networkId: Number,
      enabled: true,
      defaultCountry: String
    },

    /**
     * url template
     *
     * @memberof models.MovieOfTheNight#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/settings/movienight',

    /**
     * public url template
     *
     * @memberof models.MovieOfTheNight#
     * @type {String}
     */
    _publicUrlTemplate: 'networks/{{::networkId}}/settings/movienight',

    /**
     * Prepare note
     *
     * @memberof models.MovieOfTheNight#
     * @override
     */
    _prepare: function () {},

    /**
     * Get underlying object
     *
     * @memberof models.MovieOfTheNight#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      delete this.networkId
      return Entity.prototype._object.apply(this, arguments)
    }

  }, onOffMixin)

  /* === MovieOfTheNight static methods & fields === */

  /**
   * Generate url
   *
   * @param {Object} [o] - object over which Url will be interpolated
   * @param {String} [url]
   * @return {String}
   */
  MovieOfTheNight.generateUrl = function (url = '', o) {
    o = o || {}

    const cast = $injector.get(this._name) // get constructor from injector by name
    return `${cast.prototype.$_urlTemplate(o)}` + url
  }

  /**
   * Обновить MovieAtTheNight
   *
   * @param {MovieOfTheNight} data - объект shelf с обновленными данными
   * @return {Promise} promise
   */
  MovieOfTheNight._update = function (data) {
    return $http.put(data._url, data._object())
      .then((response) => response.data)
  }

  // copy all static methods from Entity class
  Object.assign(MovieOfTheNight, Entity)
  MovieOfTheNight._name = 'MovieOfTheNight'
  MovieOfTheNight.init()

  // permissions
  MovieOfTheNight.access = {

  }

  return MovieOfTheNight
}
